import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditCardDirective } from './credit-card.directive';
export class CreditCardModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [CreditCardDirective],
  exports: [CreditCardDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CreditCardModule_tsickle_Closure_declarations() {
/** @type {?} */
CreditCardModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CreditCardModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
